$easyreels_user_recorder $mol_view
	plugins /
		<= Theme $mol_theme_auto
	tools /
	links /
	attr *
		^
		easyreels_user_recorder_mode <= mode \off
	sub <= layers /
	Preview $mol_video_player
		controls false
		autoplay true
		inline true
		muted true
		stream <= stream null
		field *
			^
			muted true
		style *
			^
			transform <= preview_transform \none
		event *
			^
			resize? <=> preview_resize? null
	Top $mol_view
		sub <= top /
	Top_row $mol_view
		sub <= top_row /
	Badge $mol_view
		attr *
			^
			easyreels_user_recorder_badge_live <= live false
		sub /
			<= badge \
	Tools $mol_view
		sub <= tool_list /
	Settings $mol_check
		hint @ \Camera and microphone
		checked? <=> devices_open? false
		sub /
			<= Settings_icon $mol_icon_cog
	Devices $mol_view
		sub <= devices_lines /
	Camera_field $mol_labeler
		title @ \Camera
		content /
			<= Camera_select $mol_select
				dictionary <= camera_options *
				value? <=> camera_device? \
				enabled <= camera_select_enabled true
	Mic_field $mol_labeler
		title @ \Microphone
		content /
			<= Mic_select $mol_select
				dictionary <= mic_options *
				value? <=> mic_device? \
				enabled <= mic_select_enabled true
	Mic_note $mol_paragraph
		title @ \Change the microphone before you start
	Devices_close $mol_button_minor
		title @ \Done
		click? <=> devices_close? null
	Facing $mol_paragraph
		title <= facing_hint \
	Warning $mol_view
		sub <= warning_lines /
			<= Warning_title $mol_paragraph
				title @ \Uploads are falling behind
			<= Warning_detail $mol_paragraph
				title <= warning_detail \
			<= Warning_problem $mol_paragraph
				title <= warning_problem \
	Limit $mol_view
		sub /
			<= Limit_title $mol_paragraph
				title @ \Limit reached
			<= Limit_detail $mol_paragraph
				title <= limit_detail \
	Status $mol_paragraph
		title <= status \
	Error $mol_view
		sub <= error_lines /
			<= Error_text $mol_paragraph
				title <= error \
			<= Error_detail $mol_paragraph
				title <= error_detail \
	Bottom $mol_view
		sub <= bottom /
	Meter $mol_portion
		portion <= level 0
	Controls $mol_view
		sub <= controls /
	Off $mol_view
		sub <= off_lines /
	Sheet $mol_view
		sub <= sheet_lines /
	Summary $mol_paragraph
		title <= summary \
	Segments $mol_list
		rows <= segment_links /
	Segment_link* $mol_link
		uri <= segment_uri* \
		target \_blank
		title <= segment_title* \
	Links $mol_view
		sub <= links
	Sheet_controls $mol_view
		sub <= sheet_controls /
	Preview_button $mol_button_major
		title @ \Turn on camera
		enabled <= ready_enabled true
		click? <=> preview_click? null
	Switch $mol_button_minor
		hint @ \Switch camera
		enabled <= switch_enabled true
		click? <=> switch_click? null
		sub /
			<= Switch_icon $mol_icon_camera_flip
	Start $mol_button_major
		title @ \Start
		enabled <= ready_enabled true
		click? <=> start_click? null
	Stop $mol_button_major
		title @ \Stop
		click? <=> stop_click? null
	Retry $mol_button_major
		title @ \Try again
		click? <=> retry_click? null
	Again $mol_button_minor
		title @ \Record another
		click? <=> again_click? null
